import Vue from 'vue'
import Vuex from 'vuex'

import {lowercaseKeys} from 'util'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'en',
    meta: [],
    menu: [],
    header: null,
    sections: null,
    credits: null,
    relatedarticles: null,
    fbcomment: null,
    premium: false,
    user: null,
    formlink: '',
    modalOpen: false
  },
  getters: {},
  mutations: {
    pushResponse (state, response) {
      const responseKeys = {
        lang: 'lang',
        meta: 'meta',
        menu: 'menu',
        header: 'header',
        sections: 'sections',
        credits: 'credits',
        relatedarticles: 'relatedarticles',
        fbcomment: 'fbcomment',
        premium: 'premium',
        user: 'user',
        formlink: 'formlink'
      }
      Object.keys(responseKeys).forEach(key => {
        const value = response[responseKeys[key]]
        if (value == null) return
        state[key] =
          typeof value !== 'object' || Array.isArray(value)
            ? value
            : lowercaseKeys(value)
      })
    },
    toggleModal (state, payload) {
      state.modalOpen = payload
    }
  },
  actions: {},
  strict: process.env.NODE_ENV !== 'production'
})
